import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {CircularProgress, Grid} from "@material-ui/core/";
import ptLocale from "date-fns/locale/pt-BR";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

//components
import CardFile from '../childrens/CardFile/.mixins/CardFile';

//css
import SectionCss from './styles';
const useStyles = SectionCss();

function Section(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={'container'} style={{maxWidth:700}}>
                <div className={classes.boxForm}>
                    <Typography variant="h5" component="h3" className={classes.title}>
                        {props.state.tipo} {props.state.title}
                    </Typography>
                    {props.state.isLoading &&
                        <div align="center">
                            <br/>
                            <CircularProgress/>
                        </div>
                    }
                    {!props.state.isLoading &&
                        <form 
                            id={"formSection"}
                            className={classes.container} 
                            noValidate 
                            autoComplete="off"
                            encType="multipart/form-data"
                        >
                            <TextField variant={"filled"}
                                id="standard-name"
                                label="Título"
                                className={classes.textField}
                                InputProps={{
                                    className: classes.multilineColor
                                }}
                                margin="normal"
                                onChange={(e)=>{props.setState({titulo:e.target.value})}}
                                value={props.state.titulo}
                            />
                            <TextField variant={"filled"}
                                id="standard-multiline-static"
                                label="Descrição"
                                multiline
                                rows="4"
                                className={classes.textField}
                                InputProps={{
                                    className: classes.multilineColor
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLabel
                                }}
                                margin="normal"
                                onChange={(e)=>{props.setState({descricao:e.target.value})}}
                                value={props.state.descricao}
                            />
                            <br/>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <MuiPickersUtilsProvider 
                                        utils={DateFnsUtils}
                                        locale={ptLocale}
                                    >
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="dt_lancamento"
                                            label="Início Vigência"
                                            format="dd/MM/yyyy"
                                            invalidDateMessage="Data inválida"
                                            cancelLabel="Cancelar"
                                            onChange={(e)=>{props.setState({lancamento: e, termino: null})}}
                                            value={props.state.lancamento}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            InputProps={{
                                                className: classes.multilineColor
                                            }}
                                            className={classes.textField}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={6}>
                                    <MuiPickersUtilsProvider 
                                        utils={DateFnsUtils}
                                        locale={ptLocale}
                                    >
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="dt_termino"
                                            label="Fim vigência"
                                            format="dd/MM/yyyy"
                                            invalidDateMessage="Data inválida"
                                            cancelLabel="Cancelar"
                                            onChange={(e)=>{props.setState({termino: e})}}
                                            value={props.state.termino}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            InputProps={{
                                                className: classes.multilineColor
                                            }}
                                            className={classes.textField}
                                            minDate={props.state.lancamento}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Grid>
                            <div className={classes.cardFile} align={'center'}>
                                <CardFile {...props}/>
                            </div>
                            <br/>
                            <div className={classes.buttonAction} align="right">
                                <Button 
                                    className={classes.buttonCancelar} 
                                    onClick={props.handleCloseModel}
                                >
                                    Cancelar
                                </Button>
                                <Button variant="contained" color="primary" onClick={()=>{props.sendForm()}}>
                                    {'Salvar'}
                                </Button>
                            </div>
                            <br/>
                        </form>
                    }
                </div>
            </div>
        </div>
    );
}

export default class SectionForm extends Component {

    render() {
        return(<Section {...this.props}/>);
    }

}